module.exports = __webpack_public_path__ + "static/media/Capture.9aad51f3.PNG";